module.exports = __webpack_public_path__ + "static/media/dismorfico.57a86959.png";